import { Link } from 'react-router-dom';
import { Activity } from 'lucide-react';
import { useAuth } from '@/contexts/AuthContext';

export function PilotHealthLinkCard() {
  const { mode, role, isSolo } = useAuth();
  if (mode !== 'real' || isSolo || !(role === 'manager' || role === 'admin')) return null;
  return (
    <Link to="/pilot-health" className="flex items-center justify-between p-4 rounded-lg border border-border hover:border-primary/50 transition-colors group">
      <div className="flex items-center gap-3">
        <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center">
          <Activity className="h-5 w-5 text-primary" />
        </div>
        <div>
          <p className="text-sm font-medium">Pilot Health</p>
          <p className="text-xs text-muted-foreground">Adoption, activations, and stale reps — last 7 days.</p>
        </div>
      </div>
      <span className="text-sm text-primary group-hover:translate-x-0.5 transition-transform">→</span>
    </Link>
  );
}